// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".table_block[data-v-a4ea68e8]{background:#fff;border-radius:10px;padding:15px}.page_out[data-v-a4ea68e8]{width:100%;text-align:right;background-color:#0ff;cursor:pointer}", ""]);
// Exports
module.exports = exports;
